// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__XY358","badges":"styles_badges__V8nhV"};